import classNames from 'classnames';

import { unitMapping } from 'lib/style';
import type { Color } from 'style/types';

type Props = {
  shiny?: boolean;
  color?: Color;
  size?: keyof typeof unitMapping;
};

export const CollectionStar = ({ shiny, color, size = 1.5 }: Props) => (
  <svg
    viewBox="0 0 160 160"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ width: unitMapping[size], height: unitMapping[size] }}
    className={classNames({ shiny })}
  >
    <path
      d="M102.275 102.275l57.721-14.89V72.61l-57.721-14.888L87.387 0H72.61L57.72 57.72 0 72.61v14.776l57.72 14.889 14.89 57.721h14.777l14.888-57.721z"
      fill={color || 'currentColor'}
    />
  </svg>
);
